import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';

Vue.use(BootstrapVue);


//////////////////
// WEBPACK FOOTER
// ./.nuxt/bootstrap-vue.js
// module id = ./.nuxt/bootstrap-vue.js
// module chunks = 20